// extracted by mini-css-extract-plugin
module.exports = {"Main":"OnHandItemClearInput_Main__1yqdq"};